'use client'

import { useAuthListener } from '../hooks/use-auth-listener'

/**
 * Auth provider component.
 * Listens to Supabase auth state changes and syncs with Zustand.
 * Place this in the root layout.
 *
 * @example
 * ```tsx
 * // src/app/layout.tsx
 * <AuthProvider>
 *   {children}
 * </AuthProvider>
 * ```
 */
export function AuthProvider({ children }: { children: React.ReactNode }) {
	useAuthListener()
	return <>{children}</>
}
